import { PEOPLE_CONTEXT } from 'store/reducers/people/people-reducer';
import styled from 'styled-components';

export const PeopleMobileSwitcherWrapper = styled.div`
  width: calc(100% - 32px);
  height: 40px;

  display: flex;
  flex-direction: ${({ theme }) =>
    theme.context === PEOPLE_CONTEXT.COLLECTIVE_DIRECTORY ? 'row' : 'row-reverse'};
  justify-content: space-around;
  align-items: center;
  align-self: center;
  gap: 6px;

  padding: 0px 16px;

  border-radius: 20px;
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0px 0px 50px -10px rgba(0, 0, 0, 0.25);

  position: relative;
`;

export const PeopleMobileSwitcherTitle = styled.h3`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  color: rgba(23, 28, 51, 0.5);
`;

export const PeopleMobileSwitcherContainer = styled.div`
  width: 100%;

  position: absolute;
  top: 10px;
  left: 0px;

  display: flex;
  flex-direction: column;
  gap: 16px;

  padding: 0px 16px;

  background: #ffffff;
  border-radius: 24px;
  box-shadow: 5px 0px 20px -10px rgba(50, 63, 93, 0.1);

  overflow: hidden;

  z-index: 9999;
`;

export const PeopleMobileSwitcherBetaContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 2px 8px;

  border-radius: 4px;
  background: rgba(23, 28, 51, 0.3);
`;

export const PeopleMobileSwitcherBetaLabel = styled.span`
  font-weight: 700;
  font-size: 9px;
  line-height: normal;

  color: #ffffff;
`;

interface PeopleMobileSwitcherOptionContainerProps {
  active: boolean;
}

export const PeopleMobileSwitcherOptionContainer = styled.div<PeopleMobileSwitcherOptionContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  ${({ active }) =>
    active &&
    `
    ${PeopleMobileSwitcherTitle} {
      color: #ffffff;
    }

    ${PeopleMobileSwitcherBetaContainer} {
      background: var(--color-error);
    }
  `}
`;
